module.exports = __webpack_public_path__ + "img/xt.6484471e.svg";